(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/assets/javascripts/game-view.js') >= 0) return;  svs.modules.push('/modules/racing-game/assets/javascripts/game-view.js');
"use strict";


const {
  lazy
} = svs.components.lbUtils.lazy;
const {
  Route,
  Switch,
  withRouter
} = svs.app.ReactRouter;
const {
  StreamPlayer
} = svs.racing.streamplayer;
const {
  Statistics
} = svs.racing_game.components.statistics;
const {
  StaticTabs,
  StaticTabsContent
} = svs.racing_game.components.staticTabs;
const {
  Play
} = svs.racing_game.components.play;
const {
  useCurrentTab
} = svs.racing_game.components.hooks;
const {
  racingRoutes,
  racingMyGamesRoutes,
  statisticsRoutes
} = svs.racing_game.routes;
const {
  CampaignFlerp
} = svs.components.lbUi.campaignFlerp;
const isMobile = svs.core.detect.formfactor.mobile();
const isSelfService = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') ? svs.core.config.data.svsconfig.isSelfService : false;
const LazyMyGaming = lazy('react:my-gaming', () => svs.racing_game.components.myGaming.MyGaming);
const GameView = withRouter(_ref => {
  let {
    match,
    location,
    staticTabs
  } = _ref;
  const currentTab = useCurrentTab(match, location);
  return React.createElement(React.Fragment, null, React.createElement(CampaignFlerp, {
    branding: "racing"
  }), isMobile && React.createElement(StreamPlayer, null), React.createElement(Switch, null, !isSelfService && React.createElement(Route, {
    component: LazyMyGaming,
    exact: true,
    path: racingMyGamesRoutes
  }), isMobile && React.createElement(Route, {
    exact: true,
    path: statisticsRoutes
  }, React.createElement(Statistics, null)), React.createElement(Route, {
    exact: true,
    path: racingRoutes
  }, isMobile && React.createElement(StaticTabs, {
    tabs: staticTabs
  }), !isMobile || currentTab === 'spela' ? React.createElement(Play, null) : React.createElement(StaticTabsContent, {
    tabs: staticTabs
  }))));
});
svs.racing_game.GameView = GameView;

 })(window);